import React from "react";
import * as Mui from "@mui/material";
import { validate } from "shared/yup";
import * as yup from "yup";
import { Integration } from "model/integration";
import { SimpleIntegrationModal } from "../../simple-integration-modal";

export const validationSchema = {
	name: yup.string().required("Name is required"),
	url: yup.string().required("Url is required").matches(/^https?:\/\//i, "Url must start with http:// or https://"),
};

interface Props {
	open: boolean;
	onClose: () => void;
	integration: Integration;
	name?: string;
	url?: string;
	showValidation: boolean;
	onNameChange: (name: string) => void;
	onUrlChange: (url: string) => void;
	onSave: () => void;
}

export class CustomLtsModal extends React.Component<Props> {

	public render() {
		const { open, onClose, integration, name, url, showValidation, onNameChange, onUrlChange, onSave } = this.props;
		const errors = validate(validationSchema, { name, url });

		return (
			<SimpleIntegrationModal open={open} onClose={onClose} integration={integration}>
				<Mui.Grid container direction="column" spacing={2}>
					<Mui.Grid item>
						<Mui.TextField
							label="Name" placeholder={integration.integrationType.name}
							value={name || ""} onChange={e => onNameChange(e.target.value)}
							helperText={showValidation && errors && errors.name}
							error={showValidation && errors && !!errors.name}
							fullWidth margin="dense" variant="outlined"
						/>
					</Mui.Grid>
					<Mui.Grid item>
						<Mui.TextField
							label="URL" value={url || ""} onChange={e => onUrlChange(e.target.value)}
							helperText={showValidation && errors && errors.url}
							error={showValidation && errors && !!errors.url}
							fullWidth margin="dense" variant="outlined"
						/>
					</Mui.Grid>
					<Mui.Grid item>
						<Mui.Button variant="contained" color="primary" onClick={onSave}>Save</Mui.Button>
					</Mui.Grid>
				</Mui.Grid>
			</SimpleIntegrationModal>
		);
	}

}
